import { Box, Typography } from "@mui/material";
import CustomButton from "../ui/CustomButton";

const ReminderExpiryBanner = ({ onSetUp }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.25,
      p: 2,
      borderRadius: "16px",
      bgcolor: "rgba(201, 226, 255, 0.55)",
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography sx={{ fontSize: "15px", fontWeight: 600, color: "#000" }}>
        Never miss a good deal
      </Typography>
      <Typography
        sx={{
          fontSize: "13px",
          color: "#555",
          mt: 0.25,
          lineHeight: 1.4,
        }}
      >
        Receive Telegram alerts for new and expiring deals that matter to you.
      </Typography>
    </Box>
    <CustomButton
      variant="primary"
      onClick={onSetUp}
      preventSpam={false}
      sx={{
        flexShrink: 0,
        px: 1.75,
        py: 0.45,
        minHeight: 34,
        fontSize: "13px",
        lineHeight: 1.2,
      }}
    >
      Set up
    </CustomButton>
  </Box>
);

export default ReminderExpiryBanner;
